<template>
  <div>
    <!-- 商品主分类 -->
    <div class="add">
      <!-- 添加分类 -->
      <el-button type="success" class="AddTheClassification" size="small" @click="add" v-if="isAuth(393)">
        {{ $t("message.AddTheClassification") }}</el-button>
    </div>
    <div class="table">
      <!--     default-expand-all 全部展開 -->
      <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#F0F0F0 ' }" row-key="id"
        :tree-props="{ children: 'childs', hasChildren: 'hasChildren' }">
        <!-- 中文名称 -->
        <el-table-column :label="$t('message.ChineseName')" prop="chinese_name" width="300px">
        </el-table-column>
        <!-- 译文名称 -->
        <el-table-column :label="$t('message.translationName')" align="center" prop="translate_name">
        </el-table-column>
        <!--  排序-->
        <el-table-column :label="$t('message.sort')" align="center" prop="sort" width="50px">
        </el-table-column>
        <!--  pc版主图 -->

        <!--Web默认图标  -->
        <el-table-column :label="$t('message.defaultIcon')" align="center" width="120px">
          <template slot-scope="scope">
            <img :src="scope.row.icon_default" alt="" />
          </template>
        </el-table-column>
        <!-- Web悬停图标 -->

        <el-table-column :label="$t('message.triggerIcon')" align="center" width="150px">
          <template slot-scope="scope">
            <img :src="scope.row.icon_change" alt="" />
          </template>
        </el-table-column>
        <!--  App图标-->
        <el-table-column :label="$t('message.appImg')" align="center" width="120px">
          <template slot-scope="scope">
            <img :src="scope.row.icon_app" alt="" />
          </template>
        </el-table-column>

        <!-- 描述 -->
        <el-table-column :label="$t('message.note')" align="center" prop="remark">
        </el-table-column>
        <!--操作  -->
        <el-table-column :label="$t('message.operation')" align="center" width="120px">
          <template slot-scope="scope">
            <div class="a-flex">
              <i class="el-icon-edit" @click="edit(scope.row)" v-if="isAuth(393)"></i>
              <i class="el-icon-delete" @click="mainGoodsGroupDelete(scope.row.id)" v-if="isAuth(394)"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 添加编辑分类 -->

    <el-dialog :title="dialogVisibleTitle" :close-on-click-modal="false" :visible.sync="dialogVisible" width="600px"
      center>
      <div class="form">
        <el-form :model="datas" :rules="rules" ref="form" label-width="120px" class="demo-ruleForm">
          <!-- 中文名称： -->
          <el-form-item :label="$t('message.ChineseName') + '：'" prop="chinese_name">
            <el-input v-model="datas.chinese_name" onfocus="this.select()"></el-input>
          </el-form-item>
          <!-- 译文名称： -->
          <el-form-item :label="$t('message.translationName') + '：'" prop="translate_name">
            <el-input v-model="datas.translate_name" onfocus="this.select()"></el-input>
          </el-form-item>

          <!--排序：  -->
          <el-form-item :label="$t('message.sort') + '：'" prop="sort">
            <div class="input">
              <el-input v-model="datas.sort" onfocus="this.select()"></el-input>
            </div>
            <!-- *数字越大越靠前 -->
            <span style="color: #b4272d">{{ $t("message.theHigherTheNumber") }}
            </span>
          </el-form-item>
          <!-- 上级分类： -->
          <el-form-item :label="$t('message.TheCigherClassification') + '：'">
            <el-cascader v-model="datas.parent_ids" :options="tableData" :props="{
              checkStrictly: true,
              label: 'chinese_name',
              children: 'childs',
              expandTrigger: 'hover',
              value: 'id',
            }" clearable filterable></el-cascader>
          </el-form-item>

          <!-- Web默认图标： -->
          <el-form-item :label="$t('message.defaultIcon') + '：'">
            <el-upload action="#" :show-file-list="false" :http-request="httpupDefault"
              :before-upload="beforeAvatarUpload">
              <img v-if="datas.icon_default" :src="datas.icon_default" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <!-- Web悬停图标： -->
          <el-form-item :label="$t('message.triggerIcon') + '：'">
            <el-upload action="#" :show-file-list="false" :http-request="httpupTrigger"
              :before-upload="beforeAvatarUpload">
              <img v-if="datas.icon_change" :src="datas.icon_change" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <!-- App图标： -->
          <el-form-item :label="$t('message.appImg') + '：'">
            <el-upload action="#" :show-file-list="false" :http-request="httpupApp"
              :before-upload="beforeAvatarUpload">
              <img v-if="datas.icon_app" :src="datas.icon_app" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <!-- 描述： -->
          <el-form-item :label="$t('message.note') + '：'">
            <el-input v-model="datas.remark" onfocus="this.select()"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 确定 -->
        <el-button type="primary" @click="mainGoodsGroupSave">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      datas: {},
      rules: {
        chinese_name: [
          {
            required: true,
            message: this.$t("message.pleaseChineseName"),
            trigger: "blur",
          },
        ],
        translate_name: [
          {
            required: true,
            message: this.$t("message.pleaseTranslationName"),
            trigger: "blur",
          },
        ],
      },
      dialogVisibleTitle: "",
      dialogVisible: false,
    };
  },
  created() {
    this.mainGoodsGroup();
  },
  methods: {
    mainGoodsGroup() {
      this.$api.siteConfiguration.mainGoodsGroup().then((res) => {
        this.tableData = res.data;
      });
    },
    // 新增
    add() {
      this.datas = {
        chinese_name: "",
        parent_ids: [],
        translate_name: "",
        parent_id: "",
        icon_default: "",
        icon_change: "",
        icon_app: "",
        sort: "",
        remark: "",
      };
      this.dialogVisible = true;
      this.dialogVisibleTitle = "新增商品主分类";
    },
    // 修改
    edit(item) {
      this.datas = JSON.parse(JSON.stringify(item));
      this.datas.parent_ids = this.datas.parent_id - 0;
      this.dialogVisible = true;
      this.dialogVisibleTitle = "修改商品主分类";
    },
    // 删除
    mainGoodsGroupDelete(id) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.save"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.siteConfiguration
            .mainGoodsGroupDelete({ id })
            .then((res) => {
              if (res.code != 0) return this.$message.error(res.msg);
              this.$message.success(res.msg);

              this.mainGoodsGroup();
            });
        })
        .catch(() => { });
    },
    // Web 默认图标沿用项目 OSS 上传方法，上传结果回填原保存字段。
    async httpupDefault(file) {
      const data = await this.createClient(file);
      this.datas.icon_default = data.data;
      this.$forceUpdate();
    },
    // Web 悬停图标使用同一 OSS 上传入口。
    async httpupTrigger(file) {
      const data = await this.createClient(file);
      this.datas.icon_change = data.data;
      this.$forceUpdate();
    },

    // 图片格式
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";

      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
      }
      return isJPG || isPNG || isSVG;
    },
    // App 图标上传完成后，保留原有回显及分类保存逻辑。
    async httpupApp(file) {
      const data = await this.createClient(file);
      this.datas.icon_app = data.data;
      this.$forceUpdate();
    },
    mainGoodsGroupSave() {
      if (this.datas.parent_ids.length > 0) {
        this.datas.parent_id =
          this.datas.parent_ids[this.datas.parent_ids.length - 1];
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.siteConfiguration
            .mainGoodsGroupSave(this.datas)
            .then((res) => {
              this.mainGoodsGroup();
              this.dialogVisible = false;
            });
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.add {
  position: absolute;
  top: 25px;
  right: 24px;
  z-index: 999;
}

/deep/.el-table__expand-icon {
  i {
    font-size: 20px;
  }
}

.a-flex {
  display: flex;

  i {
    flex: 1;
    font-size: 20px;
    cursor: pointer;
  }
}

/deep/.el-table__row {
  background-color: #edeff4;
}

.form {
  padding: 20px 10px 10px;
  border-radius: 6px;
  background-color: #edeff4;

  /deep/.el-upload {
    width: 40px;
    height: 40px;
    border: 1px dashed #ccc;
    border-radius: 4px;
  }

  .el-cascader {
    width: 100%;
  }

  .avatar {
    width: 40px;
    height: 40px;
  }
}
</style>
